<template>
  <div class="tool_btns">
    <div
      v-for="item in items"
      :key="item.id"
      class="tool_btn"
      @click="onClick(item)"
    >
      <div>
        <fluent-icon :icon="item.icon" />
      </div>
      <p class="paragraph paragraph--black mt_4">{{ item.title }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onClick(item) {
      this.$emit('onClick', item);
    },
  },
};
</script>

<style scoped lang="scss">
.tool_btns {
  display: flex;
  gap: 10px;
  .tool_btn {
    border: 1px solid var(--s-75);
    width: 150px;
    padding: 12px;
    border-radius: 10px;
    cursor: pointer;

    &:hover {
      background: var(--s-25);
      color: var(--s-600);
    }
  }
}
</style>
